import Query from 'library/util/query';
import { jsonToInputParams } from 'library/util/graph';

const UpdateSurveyMutation = async (
  survey_id,
  category_id = 1,
  answered_questions = []
) =>
  await Query(`
    mutation {
    	update_career_cluster_survey(${jsonToInputParams({
        survey_id,
        category_id,
        answered_questions,
      })}) {
      success,
      errors,
        survey {
          id
          category {
            id
          }
          response_store {
           answered_questions
         }
        }
  	 }
    }
  `);

export default UpdateSurveyMutation;
